import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ee6adff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "p-mx-2" }
const _hoisted_3 = { class: "p-inputgroup" }
const _hoisted_4 = { class: "p-mx-2" }
const _hoisted_5 = { class: "p-mx-2" }
const _hoisted_6 = { class: "st-style p-text-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No records found", -1))
const _hoisted_8 = { class: "p-buttonset" }
const _hoisted_9 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_10 = { class: "p-grid" }
const _hoisted_11 = { class: "p-col" }
const _hoisted_12 = { class: "p-field" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "receiptType" }, "Receipt Type", -1))
const _hoisted_14 = { class: "p-col" }
const _hoisted_15 = { class: "p-field" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" NAME : ")
const _hoisted_17 = { class: "pull-right" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Email : ")
const _hoisted_19 = { class: "pull-right" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Contact : ")
const _hoisted_21 = { class: "pull-right" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Account Type : ")
const _hoisted_23 = { class: "pull-right" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "p-error" }
const _hoisted_26 = {
  key: 1,
  class: "p-error"
}
const _hoisted_27 = { class: "p-col" }
const _hoisted_28 = { class: "p-field" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "p-error" }
const _hoisted_31 = {
  key: 1,
  class: "p-error"
}
const _hoisted_32 = { class: "p-col" }
const _hoisted_33 = {
  key: 0,
  class: "p-field"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "paymentType" }, "Payment Type", -1))
const _hoisted_35 = {
  key: 0,
  class: "p-grid"
}
const _hoisted_36 = { class: "p-col-3" }
const _hoisted_37 = { class: "p-inputgroup" }
const _hoisted_38 = { class: "p-field" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Head Code : ")
const _hoisted_40 = { class: "pull-right" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" Head Name : ")
const _hoisted_42 = { class: "pull-right" }
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Nature : ")
const _hoisted_44 = { class: "pull-right" }
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" Head Type : ")
const _hoisted_46 = { class: "pull-right" }
const _hoisted_47 = { class: "p-grid" }
const _hoisted_48 = { class: "p-col-8" }
const _hoisted_49 = { class: "p-field" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { class: "p-error" }
const _hoisted_52 = {
  key: 1,
  class: "p-error"
}
const _hoisted_53 = {
  key: 0,
  class: "p-col-4"
}
const _hoisted_54 = { class: "p-field" }
const _hoisted_55 = { for: "total_paid" }
const _hoisted_56 = { class: "p-grid" }
const _hoisted_57 = { class: "p-col-12" }
const _hoisted_58 = { class: "table table-bordered total-lables" }
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { key: 1 }
const _hoisted_61 = { key: 2 }
const _hoisted_62 = { class: "p-grid" }
const _hoisted_63 = { class: "p-col-8 p-text-left" }
const _hoisted_64 = { class: "p-col-3" }
const _hoisted_65 = { class: "p-col-4 p-text-right" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "p-dialog-titlebar p-dialog-titlebar-icon" }, " Receipt Transactions ", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Receipt Payments", -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No records found", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_SearchFilter = _resolveComponent("SearchFilter")!
  const _component_PreviewAccountingReceipt = _resolveComponent("PreviewAccountingReceipt")!
  const _component_ProfilePaymentReceipt = _resolveComponent("ProfilePaymentReceipt")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Toolbar, null, {
        start: _withCtx(() => [
          _createVNode(_component_Breadcrumb, {
            home: _ctx.home,
            model: _ctx.items,
            class: "p-menuitem-text"
          }, null, 8, ["home", "model"])
        ]),
        end: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.itemFilter.type,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.itemFilter.type) = $event)),
              options: _ctx.receiptTypes,
              optionLabel: "key",
              optionValue: "value",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadList(0)))
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_InputText, {
              modelValue: _ctx.itemFilter.keyword,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.itemFilter.keyword) = $event)),
              modelModifiers: { trim: true },
              placeholder: "Receipt No"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Button, {
              icon: "pi pi-search ",
              class: "p-button-primary p-mr-1",
              onClick: _ctx.loadSearchData
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Button, {
              icon: "pi pi-calendar",
              class: "p-button-warning",
              onClick: _ctx.openFilterDialog
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Button, {
              icon: "pi pi-plus",
              class: "p-button-success",
              onClick: _ctx.openDialog
            }, null, 8, ["onClick"])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("p", _hoisted_6, [
        _createElementVNode("b", null, _toDisplayString(_ctx.statement), 1)
      ]),
      _createVNode(_component_DataTable, {
        first: _ctx.goToFirstLink,
        "onUpdate:first": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.goToFirstLink) = $event)),
        firstModifiers: { sync: true },
        value: _ctx.lists,
        lazy: true,
        paginator: _ctx.checkPagination,
        rows: _ctx.limit,
        totalRecords: _ctx.totalRecords,
        scrollable: true,
        onPage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onPage($event))),
        class: "p-datatable-sm p-datatable-striped p-datatable-gridlines"
      }, {
        empty: _withCtx(() => [
          _hoisted_7
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, { header: "Created Date" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(_ctx.formatDateTime(slotProps.data.created_at)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Updated Date" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(_ctx.formatDateTime(slotProps.data.updated_at)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Receipt Date" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(_ctx.formatDate(slotProps.data.receipt_date)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "receipt_no",
            header: "Receipt No"
          }),
          _createVNode(_component_Column, { header: "Account Title" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.profile_name.profileName), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Total Amount" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(slotProps.data.total_bill)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Balance" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(
                                _ctx.calculateBalance(
                                    slotProps.data.total_bill,
                                    slotProps.data.receipt_balance
                                )
                            )), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "description",
            header: "Description"
          }),
          _createVNode(_component_Column, {
            field: "user_name.userName",
            header: "Created By"
          }),
          _createVNode(_component_Column, { header: "Store Name" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.branch.branchName) + " ( " + _toDisplayString(slotProps.data.branch.branchCode) + " ) ", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            exportable: false,
            header: "Action"
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", _hoisted_8, [
                _createVNode(_component_Button, {
                  icon: "pi pi-pencil",
                  class: "p-button-rounded p-button-success",
                  onClick: ($event: any) => (_ctx.editIem(slotProps.data))
                }, null, 8, ["onClick"]),
                _createVNode(_component_Button, {
                  icon: "pi pi-chart-bar",
                  class: "p-button-rounded p-button-warning",
                  onClick: ($event: any) => (_ctx.openTransactionDialog(slotProps.data))
                }, null, 8, ["onClick"]),
                _createVNode(_component_Button, {
                  icon: "pi pi-print",
                  class: "p-button-rounded p-button-primary",
                  onClick: ($event: any) => (_ctx.openPreviewDialog(slotProps.data))
                }, null, 8, ["onClick"]),
                _createVNode(_component_Button, {
                  icon: "pi pi-money-bill",
                  disabled: 
                                    _ctx.calculateBalance(
                                        slotProps.data.total_bill,
                                        slotProps.data.receipt_balance
                                    ) == 0
                                ,
                  class: "p-button-rounded p-button-danger",
                  onClick: ($event: any) => (
                                    _ctx.openReceivePaymentDialog(slotProps.data)
                                )
                }, null, 8, ["disabled", "onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["first", "value", "paginator", "rows", "totalRecords"]),
      _createVNode(_component_Dialog, {
        visible: _ctx.productDialog,
        "onUpdate:visible": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.productDialog) = $event)),
        style: { width: '100vw' },
        position: "top",
        class: "p-fluid p-m-0 p-dialog-maximized"
      }, {
        header: _withCtx(() => [
          _createElementVNode("h5", _hoisted_9, _toDisplayString(_ctx.dialogTitle), 1)
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _createVNode(_component_Button, {
                  type: "button",
                  label: "Clear All",
                  icon: "pi pi-times",
                  class: "p-button-danger pull-left btn-width",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.clearLines()))
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_65, [
              _createVNode(_component_Button, {
                type: "button",
                label: "Add New",
                icon: "pi pi-plus-circle",
                class: "p-button-success btn-width",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.addNewLine()))
              }),
              _createVNode(_component_Button, {
                type: "submit",
                label: "Save",
                disabled: 
                                    _ctx.item.profileID == 0 ||
                                        _ctx.state.itemList.length <= 0 ||
                                        _ctx.netTotal <= 0
                                ,
                icon: "pi pi-check",
                class: "p-button-primary btn-width",
                onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.saveItem(!_ctx.v$.$invalid)), ["prevent"]))
              }, null, 8, ["disabled"])
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_Dropdown, {
                  id: "receiptType",
                  modelValue: _ctx.item.type,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.item.type) = $event)),
                  onChange: _ctx.setReceiptType,
                  options: _ctx.receiptTypes,
                  optionLabel: "key",
                  optionValue: "value"
                }, null, 8, ["modelValue", "onChange", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", {
                  for: "selectedProfile",
                  class: _normalizeClass({
                                    'p-error':
                                        _ctx.v$.selectedProfile.$invalid && _ctx.submitted
                                })
                }, "Account Holders", 2),
                _createVNode(_component_AutoComplete, {
                  delay: 1000,
                  minLength: 3,
                  onItemSelect: _cache[6] || (_cache[6] = ($event: any) => (_ctx.saveProfile($event))),
                  scrollHeight: "500px",
                  modelValue: _ctx.v$.selectedProfile.$model,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.v$.selectedProfile.$model) = $event)),
                  suggestions: _ctx.profilerList,
                  placeholder: "Search Profile",
                  onComplete: _cache[8] || (_cache[8] = ($event: any) => (_ctx.searchProfiler($event))),
                  dropdown: false,
                  autoFocus: ""
                }, {
                  item: _withCtx((slotProps) => [
                    _createElementVNode("div", null, [
                      _hoisted_16,
                      _createElementVNode("b", _hoisted_17, _toDisplayString(slotProps.item.account_title.toUpperCase()), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_18,
                      _createElementVNode("span", _hoisted_19, _toDisplayString(slotProps.item.email_address), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_20,
                      _createElementVNode("span", _hoisted_21, _toDisplayString(slotProps.item.contact_no), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_22,
                      _createElementVNode("span", _hoisted_23, _toDisplayString(slotProps.item.account_type), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "suggestions"]),
                (_ctx.v$.selectedProfile.$error && _ctx.submitted)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.selectedProfile
                                        .$errors, (error, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                          id: "p-error",
                          key: index
                        }, [
                          _createElementVNode("small", _hoisted_25, _toDisplayString(error.$message), 1)
                        ]))
                      }), 128))
                    ]))
                  : (
                                    (_ctx.v$.selectedProfile.$invalid &&
                                        _ctx.submitted) ||
                                        _ctx.v$.selectedProfile.$pending.$response
                                )
                    ? (_openBlock(), _createElementBlock("small", _hoisted_26, _toDisplayString(_ctx.v$.selectedProfile.required.$message.replace(
                                        "Value",
                                        "Account Holder"
                                    )), 1))
                    : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("label", {
                  for: "receiptDate",
                  class: _normalizeClass({
                                    'p-error':
                                        _ctx.v$.receiptDate.$invalid && _ctx.submitted
                                })
                }, "Date", 2),
                _createVNode(_component_Calendar, {
                  id: "receiptDate",
                  modelValue: _ctx.v$.receiptDate.$model,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.v$.receiptDate.$model) = $event)),
                  class: _normalizeClass({
                                    'p-invalid':
                                        _ctx.v$.receiptDate.$invalid && _ctx.submitted
                                }),
                  selectionMode: "single",
                  dateFormat: "dd-mm-yy"
                }, null, 8, ["modelValue", "class"]),
                (_ctx.v$.receiptDate.$error && _ctx.submitted)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.receiptDate
                                        .$errors, (error, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                          id: "p-error",
                          key: index
                        }, [
                          _createElementVNode("small", _hoisted_30, _toDisplayString(error.$message), 1)
                        ]))
                      }), 128))
                    ]))
                  : (
                                    (_ctx.v$.receiptDate.$invalid && _ctx.submitted) ||
                                        _ctx.v$.receiptDate.$pending.$response
                                )
                    ? (_openBlock(), _createElementBlock("small", _hoisted_31, _toDisplayString(_ctx.v$.receiptDate.required.$message.replace(
                                        "Value",
                                        "Date"
                                    )), 1))
                    : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              (_ctx.item.id == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _hoisted_34,
                    _createVNode(_component_Dropdown, {
                      id: "paymentType",
                      modelValue: _ctx.item.paymentType,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.item.paymentType) = $event)),
                      options: _ctx.methodList,
                      optionLabel: "cardName"
                    }, null, 8, ["modelValue", "options"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.item.type == 'RFD')
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _createVNode(_component_InputText, {
                      modelValue: _ctx.receiptNO,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.receiptNO) = $event)),
                      modelModifiers: { trim: true },
                      placeholder: "Search Receipt No"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_Button, {
                      icon: "pi pi-search ",
                      class: "p-button-danger p-mr-1",
                      onClick: _ctx.searchReceiptNo
                    }, null, 8, ["onClick"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_38, [
            _createVNode(_component_DataTable, {
              value: _ctx.state.itemList,
              class: "p-datatable-sm p-datatable-striped p-datatable-gridlines",
              responsiveLayout: "scroll"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  header: "ACCOUNT NAME",
                  style: {"width":"30%"}
                }, {
                  body: _withCtx((slotProps) => [
                    _createVNode(_component_AutoComplete, {
                      delay: 1000,
                      minLength: 3,
                      onItemSelect: ($event: any) => (
                                        _ctx.saveAccountHead($event, slotProps.data)
                                    ),
                      scrollHeight: "500px",
                      modelValue: slotProps.data.accountHead,
                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.accountHead) = $event),
                      suggestions: _ctx.accountHeadList,
                      placeholder: "Search Account",
                      onComplete: _cache[12] || (_cache[12] = ($event: any) => (_ctx.searchAccountHead($event))),
                      dropdown: false,
                      class: _normalizeClass([{
                                        'p-invalid':
                                            this.validateHeadList.includes(
                                                _ctx.state.itemList.indexOf(
                                                    slotProps.data
                                                )
                                            ) && _ctx.submitted
                                    }, "p-p-1"])
                    }, {
                      item: _withCtx((slotProps) => [
                        _createElementVNode("div", null, [
                          _hoisted_39,
                          _createElementVNode("b", _hoisted_40, _toDisplayString(slotProps.item.account_code.toUpperCase()), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_41,
                          _createElementVNode("b", _hoisted_42, _toDisplayString(slotProps.item.account_name), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_43,
                          _createElementVNode("span", _hoisted_44, _toDisplayString(slotProps.item
                                                        .account_nature), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_45,
                          _createElementVNode("span", _hoisted_46, _toDisplayString(slotProps.item.account_type), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["onItemSelect", "modelValue", "onUpdate:modelValue", "suggestions", "class"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  header: "QTY",
                  style: {"width":"10%"}
                }, {
                  body: _withCtx((slotProps) => [
                    _createVNode(_component_InputNumber, {
                      useGrouping: false,
                      modelValue: slotProps.data.quantity,
                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.quantity) = $event),
                      disabled: slotProps.data.accountID == 0,
                      class: "p-p-1",
                      allowEmpty: false
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  header: 'PRICE ('+_ctx.currency+')',
                  style: {"width":"10%"}
                }, {
                  body: _withCtx((slotProps) => [
                    _createVNode(_component_InputNumber, {
                      mode: "decimal",
                      maxFractionDigits: 2,
                      minFractionDigits: 2,
                      disabled: slotProps.data.accountID == 0,
                      modelValue: slotProps.data.price,
                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.price) = $event),
                      allowEmpty: false,
                      class: "p-p-1"
                    }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  header: "DISC (%)",
                  style: {"width":"10%"}
                }, {
                  body: _withCtx((slotProps) => [
                    _createVNode(_component_InputNumber, {
                      mode: "decimal",
                      useGrouping: false,
                      maxFractionDigits: 2,
                      minFractionDigits: 2,
                      modelValue: slotProps.data.discount,
                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.discount) = $event),
                      suffix: "%",
                      min: 0,
                      max: 100,
                      allowEmpty: false,
                      class: "p-p-1",
                      disabled: slotProps.data.accountID == 0
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                (_ctx.taxNames[0].show == 'true')
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 0,
                      header: _ctx.taxNames[0].taxName + '(%)',
                      style: {"width":"10%"}
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode(_component_InputNumber, {
                          mode: "decimal",
                          useGrouping: false,
                          maxFractionDigits: 2,
                          minFractionDigits: 2,
                          suffix: "%",
                          min: 0,
                          max: 100,
                          allowEmpty: false,
                          modelValue: slotProps.data.tax1Value,
                          "onUpdate:modelValue": ($event: any) => ((slotProps.data.tax1Value) = $event),
                          disabled: 
                                        _ctx.taxNames[0].optionalReq == 'Required' ||
                                            slotProps.data.accountID == 0
                                    ,
                          class: "p-p-1"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.taxNames[1].show == 'true')
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 1,
                      header: _ctx.taxNames[1].taxName + '(%)',
                      style: {"width":"10%"}
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode(_component_InputNumber, {
                          mode: "decimal",
                          useGrouping: false,
                          maxFractionDigits: 2,
                          minFractionDigits: 2,
                          suffix: "%",
                          min: 0,
                          max: 100,
                          allowEmpty: false,
                          modelValue: slotProps.data.tax2Value,
                          "onUpdate:modelValue": ($event: any) => ((slotProps.data.tax2Value) = $event),
                          disabled: 
                                        _ctx.taxNames[1].optionalReq == 'Required' ||
                                            slotProps.data.accountID == 0
                                    ,
                          class: "p-p-1"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_ctx.taxNames[2].show == 'true')
                  ? (_openBlock(), _createBlock(_component_Column, {
                      key: 2,
                      header: _ctx.taxNames[2].taxName + '(%)',
                      style: {"width":"10%"}
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode(_component_InputNumber, {
                          mode: "decimal",
                          useGrouping: false,
                          maxFractionDigits: 2,
                          minFractionDigits: 2,
                          suffix: "%",
                          min: 0,
                          max: 100,
                          allowEmpty: false,
                          modelValue: slotProps.data.tax3Value,
                          "onUpdate:modelValue": ($event: any) => ((slotProps.data.tax3Value) = $event),
                          disabled: 
                                        _ctx.taxNames[3].optionalReq == 'Required' ||
                                            slotProps.data.accountID == 0
                                    ,
                          class: "p-p-1"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["header"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_Column, {
                  header: "SUBTOTAL",
                  style: {"width":"10%"}
                }, {
                  body: _withCtx((slotProps) => [
                    _createVNode(_component_InputNumber, {
                      disabled: true,
                      mode: "decimal",
                      maxFractionDigits: 2,
                      minFractionDigits: 2,
                      allowEmpty: false,
                      value: _ctx.getTheSubtotal(slotProps.data),
                      class: "p-p-1"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  header: "Action",
                  style: {"width":"5%"}
                }, {
                  body: _withCtx((slotProps) => [
                    _createVNode(_component_Button, {
                      type: "button",
                      icon: "pi pi-times",
                      class: "p-button-danger pull-left",
                      onClick: ($event: any) => (_ctx.clearListItem(slotProps.data))
                    }, null, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("label", {
                  for: "description",
                  class: _normalizeClass({
                                    'p-error':
                                        _ctx.v$.description.$invalid && _ctx.submitted
                                })
                }, "Description", 2),
                _createVNode(_component_InputText, {
                  id: "description",
                  modelValue: _ctx.v$.description.$model,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.v$.description.$model) = $event)),
                  class: _normalizeClass({
                                    'p-invalid':
                                        _ctx.v$.description.$invalid && _ctx.submitted
                                })
                }, null, 8, ["modelValue", "class"]),
                (_ctx.v$.description.$error && _ctx.submitted)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_50, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.description
                                        .$errors, (error, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                          id: "p-error",
                          key: index
                        }, [
                          _createElementVNode("small", _hoisted_51, _toDisplayString(error.$message), 1)
                        ]))
                      }), 128))
                    ]))
                  : (
                                    (_ctx.v$.description.$invalid && _ctx.submitted) ||
                                        _ctx.v$.description.$pending.$response
                                )
                    ? (_openBlock(), _createElementBlock("small", _hoisted_52, _toDisplayString(_ctx.v$.description.required.$message.replace(
                                        "Value",
                                        "Description"
                                    )), 1))
                    : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.item.id == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.totalAmountStatement) + " (" + _toDisplayString(_ctx.currency) + ") ", 1),
                    _createVNode(_component_InputNumber, {
                      mode: "decimal",
                      minFractionDigits: 2,
                      maxFractionDigits: 2,
                      min: 0,
                      allowEmpty: false,
                      max: _ctx.netTotal,
                      id: "total_paid",
                      modelValue: _ctx.item.totalAmount,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.item.totalAmount) = $event))
                    }, null, 8, ["max", "modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("table", _hoisted_58, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, " Total Gross : " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.totalGross)), 1),
                  _createElementVNode("td", null, " Total Disc : " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.totalDiscAmount)), 1),
                  (_ctx.taxNames[0].show == 'true')
                    ? (_openBlock(), _createElementBlock("td", _hoisted_59, " Total " + _toDisplayString(_ctx.taxNames[0].taxName) + " : " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.totalTax1)), 1))
                    : _createCommentVNode("", true),
                  (_ctx.taxNames[1].show == 'true')
                    ? (_openBlock(), _createElementBlock("td", _hoisted_60, " Total " + _toDisplayString(_ctx.taxNames[1].taxName) + " : " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.totalTax2)), 1))
                    : _createCommentVNode("", true),
                  (_ctx.taxNames[2].show == 'true')
                    ? (_openBlock(), _createElementBlock("td", _hoisted_61, " Total " + _toDisplayString(_ctx.taxNames[2].taxName) + " : " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.totalTax3)), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("td", null, " Total Tax : " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.totalTax)), 1),
                  _createElementVNode("td", null, " Net Total : " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.netTotal)), 1),
                  _createElementVNode("td", null, " Balance : " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.totalBalance)), 1)
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_Dialog, {
        visible: _ctx.previewTransactionDialog,
        "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.previewTransactionDialog) = $event)),
        style: { width: '100vw' },
        position: "top",
        class: "p-fluid p-m-0 p-dialog-maximized"
      }, {
        header: _withCtx(() => [
          _hoisted_66
        ]),
        default: _withCtx(() => [
          _hoisted_67,
          _createVNode(_component_DataTable, {
            value: _ctx.PaymentLists,
            scrollable: true,
            class: "p-datatable-sm p-datatable-striped p-datatable-gridlines"
          }, {
            empty: _withCtx(() => [
              _hoisted_68
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, { header: "Created Date" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.formatDateTime(slotProps.data.createdDate)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "sourceType",
                header: "Type"
              }),
              _createVNode(_component_Column, { header: "Receipt No" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.receiptNo), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "paymentType",
                header: "Payment Type"
              }),
              _createVNode(_component_Column, { header: "Total Amount" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(" $ " + _toDisplayString(_ctx.formatAmount(slotProps.data.transTotalAmount)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "description",
                header: "Description"
              })
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_SearchFilter, {
        searchDetail: {
                    status: this.filterDialog,
                    dialogTitle: this.dialogTitle
                },
        onUpdateFilterStatus: _ctx.updateFilterStatus
      }, null, 8, ["searchDetail", "onUpdateFilterStatus"]),
      _createVNode(_component_PreviewAccountingReceipt, {
        PreviewAccountingReceipt: {
                    status: this.previewImageDialog,
                    dialogTitle: this.dialogTitle,
                    previewHeading: this.previewHeading,
                    receiptID: this.receiptID
                },
        onUpdatePreviewStatus: _ctx.updatePreviewStatus
      }, null, 8, ["PreviewAccountingReceipt", "onUpdatePreviewStatus"]),
      _createVNode(_component_ProfilePaymentReceipt, {
        ProfilePaymentReceipt: {
                    status: this.openReceivePayment,
                    dialogTitle: this.dialogTitle,
                    previewHeading: this.previewHeading,
                    receiptID: this.receiptID
                },
        onUpdatePaymentStatus: _ctx.updatePaymentStatus
      }, null, 8, ["ProfilePaymentReceipt", "onUpdatePaymentStatus"])
    ])
  ]))
}